<template>
  <article class="mt-4">
    <div class="row">
      <div class="col">
        <SectionTitle title="Información general" :has-line="true" />
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-4 mb-4">
        <ValidationProvider
          v-slot="{ errors }"
          name="Nombre del maestro"
          rules="required"
        >
          <CustomDropDown
            v-model="model.teacher"
            :options="collections.teachers"
            :error="errors[0]"
            :disabled="teacherSelectionDisabled"
            :clearable="false"
            custom-error-msg="El nombre del maestro es requerido."
            label="Nombre del maestro:"
            placeholder="Seleccione"
            class="px-3"
            fieldkey="id"
            fieldname="name"
          />
        </ValidationProvider>
      </div>
      <div class="col-12 col-md-4 mb-4">
        <CustomInput
          v-model="model.phone"
          label="Teléfono:"
          mask-type="Phone"
          class="px-3"
          placeholder="(__) __-____"
        />
      </div>
      <div class="col-12 col-md-4 mb-4">
        <ValidationProvider
          v-slot="{ errors }"
          :custom-messages="{
            email: 'El campo debe ser un correo electrónico válido.',
            required: 'Favor escriba correo electrónico.',
          }"
          :rules="emailValidationRules"
        >
          <CustomInput
            v-model="model.email"
            :error="errors[0]"
            :custom-error-msg="errors[0]"
            label="Correo electrónico:"
            class="px-3"
            type="email"
          />
        </ValidationProvider>
      </div>
      <div class="col-12 col-md-4 mb-4">
        <CustomInput
          :value="teacherType"
          label="Tipo de maestro:"
          class="px-3"
          disabled
        />
      </div>
      <div class="col-12 col-md-4 mb-4">
        <CustomInput
          :value="positionNumber"
          label="Número de puesto:"
          class="px-3"
          disabled
        />
      </div>
      <div class="col-12 col-md-4 mb-4">
        <CustomInput
          :value="employeeNumber"
          label="Número de empleado:"
          class="px-3"
          disabled
        />
      </div>
    </div>
  </article>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomInput from 'CustomInput';
import CustomDropDown from 'custom-drop-down';
import alert from '@/mixin/alert.mixin';

export default {
  name: 'GeneralInformation',
  mixins: [alert],
  components: {
    SectionTitle,
    CustomInput,
    CustomDropDown,
  },
  data() {
    return {};
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    isSchoolInAlliance: {
      type: Boolean,
      default: false,
    },
    teacherSelectionDisabled: {
      type: Boolean,
      required: true,
    },
    collections: {
      type: Object,
      required: true,
    },
  },
  computed: {
    emailValidationRules() {
      const rules = {
        required: true,
        email: true,
        domain: ['de.pr.gov', 'miescuela.pr'],
      };

      // US134739 : if school is in alliance then they can write any custom email
      if (this.isSchoolInAlliance) delete rules.domain;

      return rules;
    },
    model() {
      return this.value;
    },
    teacherType() {
      return (
        (this.model.teacher &&
          this.model.teacher.value.employeeClasification) ||
        '--'
      );
    },
    positionNumber() {
      return (
        (this.model.teacher && this.model.teacher.value.positionNumber) || '--'
      );
    },
    employeeNumber() {
      return this.model.teacher && !isNaN(this.model.teacher.id)
        ? this.model.teacher.id
        : '--';
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .student-search-alert-error {
  height: 0;
}
</style>
